/* eslint-disable */

import ga from 'src/components/analytics.js'
import { StorageKeys } from 'src/constants/StorageKeys';

export default ({ router }) => {
  router.afterEach((to, from) => {
    const userId = window.localStorage.getItem(StorageKeys.USERID);
    ga.logPage(to, from, userId)
  })
}